import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class BoosterNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.Booster,
    });
  }
}
